export default "__VITE_ASSET__Dr0roSh5__"